export default "/Frontend/dist/ppt-white.5dbcdc3415db7d32ed19011d8b4720af.svg";